import { apiConfig } from "../config/apiConfig";
import { apiCaching } from "../config/cachingConfig";
import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { getImageReplacemnt } from "./imageHelper";
import { updateVDomElement, VNode } from "../util/virtualDom";
import { createVDOMHash, keyGenerator } from "../util/keyGeneration";
import { insertTemplate, lookupTemplate } from "../services/woker-api";
import { checkIncognito } from "../services/worker-injector";
import { handleRatingDisplayChanges } from "./ratingDisplay";

let page = 1;
let isLoading = false;

export class TestimonialVDOM {
    private readonly data: any;
    private pageNumber: number;
    private readonly pageSize: number;
    private readonly conceptId: any;
    private readonly countryId: any;
    private readonly wrapperElement: any;
    private selectedStarRating: number;
    readonly popoverElement: HTMLElement | null;
    readonly upArrow: HTMLElement | null;
    readonly downArrow: HTMLElement | null;
    readonly resetLink: HTMLElement | null;
    private overAllRatings: string;
    private ratingCache: { [key: number]: any } = {}; // Cache for storing rating data
    private isFirstLoad = true; // check if its first load
    private static instance: TestimonialVDOM;
    // private readonly testimonialCache = DomTemplateWorker.getInstance();
    private isIncognitoMode: boolean | null = null; // Cache for incognito mode status

    static getVDOMInstance(): TestimonialVDOM {
        if (!TestimonialVDOM.instance) {
            TestimonialVDOM.instance = new TestimonialVDOM();
        }
        return TestimonialVDOM.instance;
    }
    constructor() {
        this.resetLink = document.getElementById('resetLink');
        this.upArrow = document.getElementById('upArrow');
        this.downArrow = document.getElementById('downArrow');
        this.popoverElement = document.getElementById('popover');
        this.pageNumber = 1; // Initial page number
        this.pageSize = window.innerWidth >= 768 ? 30 : 4; // Number of items per page
        this.conceptId = (document.getElementById("conceptId") as HTMLInputElement)?.value;
        this.selectedStarRating = 0;
        this.overAllRatings = '5/5';
        if (sessionStorage.getItem('countryCode') != null) {
            this.countryId = sessionStorage.getItem('countryCode')?.toLowerCase() == "us" ? "1" : "2";
        } else {
            this.countryId = (document.getElementById("countryCode") as HTMLInputElement)?.value.toLowerCase() == "us" ? "1" : "2";
        }


        const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;

        if (pageType && pageType.toLocaleLowerCase() !== "opus 2 location map") {
            const testimonialDOMisPresent = document.querySelector(".testimonials-section")
            if (testimonialDOMisPresent)
                this.getData();
        }

        this.wrapperElement = document.querySelector('.testimonials-section .container');
        let btn = `<div class="testi-btn-wrapper">                
                <a href="#" class="primary-btn"> See More...</a>                
                </div>`
        this.wrapperElement?.insertAdjacentHTML('beforeend', btn);

        const seeMoreButton = document.querySelector('.testi-btn-wrapper .primary-btn');
        if (seeMoreButton) {
            seeMoreButton.addEventListener('click', this.seeMoreData.bind(this));
        }

        this.getTotalReviews();
        //Show the list of star rating dropdown on click event of dropdown arrow
        const starRatingDrpdwn = document.getElementById('popoverBtn');
        if (starRatingDrpdwn) {
            starRatingDrpdwn.addEventListener('click', () => {
                this.handleDropdownToggle();
            });
        }


        this.resetLink?.addEventListener('click', () => {
            this.onResetClick();
        });

    }

    protected async getData() {
        this.showRatingSkeleton();
        let weblocationId: string;
        const storedWebLocationId = localStorage.getItem("franchiseWebLocationId");
        const webLocationFromElement = (document.getElementById('weblocationId') as HTMLInputElement)?.value || '';

        // decide which to use base don availability
        if (storedWebLocationId) {
            weblocationId = storedWebLocationId;
        } else {
            weblocationId = webLocationFromElement;
        }

        let selectedRating = this.selectedStarRating ? this.selectedStarRating : 5;
        try {
            // selected rating
            const result = await this.getCompleteData(weblocationId, selectedRating);
            this.showRatingContent();
            // Always hide skeleton and show real testimonials ul, even if empty
            this.toggleTestimonialsUl();

            if (!result?.length) {
                this.showNoReviewSection();
            } else {
                this.hideNoReviewSection();
                this.displayTestimonialData(result, selectedRating);
                this.checkAndCacheNextPageData(result, weblocationId, selectedRating);

            }

        } catch (error) {
            console.error('Failed to load testimonials:', error);
            this.showRatingContent();
            this.toggleTestimonialsUl();
            this.wrapperElement?.classList.add('hidden');
            isLoading = false;
            this.showNoReviewSection();
        }
    }

    protected toggleTestimonialsUl() {
        const skeletonUl = document.getElementById('testimonialskeletons');
        const realUl = document.getElementById('realtestimonials');
        if (skeletonUl) skeletonUl.classList?.add('hidden');
        if (realUl) realUl.classList?.remove('hidden');
    }

    protected checkAndCacheNextPageData(result: any, weblocationId: any, selectedRating: number) {

        // If there are more items than the page size
        if (result?.length >= this.pageSize) {
            // Cache next page of data if it's available
            this.cacheNextPageData(weblocationId, selectedRating, 2);
        }
    }

    protected async cacheNextPageData(weblocationId: any, selectedRating: number, pageNumber: number) {
        // Check if in incognito mode
        const isIncognito = await checkIncognito();
        if (isIncognito) {
            try {
                const nextPageData = await this.fetchTestimonialData(selectedRating, weblocationId, pageNumber);

                // Cache if data exists for the next page
                if (nextPageData?.length > 0) {
                    this.ratingCache[selectedRating] = this.ratingCache[selectedRating] || [];
                    this.ratingCache[selectedRating][pageNumber] = nextPageData;
                }
            } catch (error) {
                console.error('Error fetching or caching next page data:', error);
            }
        } else {
            const selector = '.testimonials-section';
            const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId || 0}/${this.countryId}/0/${pageNumber}/${this.pageSize}/${selectedRating}`;
            const cacheKey = keyGenerator(url, selector);

            try {
                // Check if data is already in IndexedDB cache
                const cachedData = await this.getFromCache(cacheKey);
                if (cachedData) {
                    console.log(`Page ${pageNumber} already cached for rating ${selectedRating}`);
                    return;
                }

                // Fetch and cache if not found
                const nextPageData = await this.fetchTestimonialData(selectedRating, weblocationId, pageNumber);

                if (nextPageData?.length > 0) {

                    // Store in IndexedDB using testimonialCache
                    await this.storeInCache(cacheKey, nextPageData);
                    console.log(`Page ${pageNumber} cached for rating ${selectedRating}`);
                }
            } catch (error) {
                console.error('Error fetching or caching next page data:', error);
            }
        }

    }
    private async handleCacheFailure() {
        // Mark that IndexedDB is unavailable
        localStorage.setItem('testimonialCacheError', 'true');
        // Reset to incognito behavior
        this.isIncognitoMode = true;
        // Clear any existing cache to prevent stale data
        this.ratingCache = {};
    }
    private async incognitoDataFetch(weblocationId: any, selectedRating: number) {
        const ratingParams = [5, 4, 3, 2, 1];

        try {
            // Fetch the 5-star rating data first
            if (this.isFirstLoad) {
                const results = await this.fetchTestimonialData(5, weblocationId);
                this.ratingCache[5] = results; // Cache the 5-star data
                // Silent fetch 4, 3, 2, and 1 star data in parallel
                ratingParams.slice(1).forEach(rating => {
                    this.fetchTestimonialData(rating, weblocationId)
                        .then(data => {
                            this.ratingCache[rating] = data;
                        })
                        .catch(error => {
                            console.error(`Error fetching ${rating} star testimonial data:`, error);
                        });
                });

                // set the first load to false after completion
                this.isFirstLoad = false;
                return results;
            }

            // If it's not the first load, just return the selected rating data
            if (this.ratingCache[selectedRating]) {
                return this.ratingCache[selectedRating];
            }

            // If the selected rating data is not in cache, fetch it
            const selectedRatingData = await this.fetchTestimonialData(selectedRating, weblocationId);
            this.ratingCache[selectedRating] = selectedRatingData;
            return selectedRatingData;

        } catch (error) {
            console.error('Error fetching testimonial data:', error);
            throw error;
        }
    }

    private async getDataIndexDB(weblocationId: any, selectedRating: number) {
        try {
            const selector = '.testimonials-section';
            if (this.isFirstLoad) {
                // First load - fetch and cache all ratings
                const ratings = [5, 4, 3, 2, 1];
                for (const rating of ratings) {
                    const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId || 0}/${this.countryId}/0/1/${this.pageSize}/${rating}`;
                    const cacheKey = keyGenerator(url, selector);

                    // Check cache first
                    const cachedData = await this.getFromCache(cacheKey);
                    if (cachedData) {
                        this.ratingCache[rating] = cachedData;
                        continue;
                    }

                    // Fetch if not in cache
                    const data = await this.fetchTestimonialData(rating, weblocationId);
                    if (data?.length) {
                        this.ratingCache[rating] = data;
                        await this.storeInCache(cacheKey, data);
                    }
                }

                // Pre-cache page 2 for 5-star ratings
                const page2Url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId || 0}/${this.countryId}/0/2/${this.pageSize}/5`;
                const page2CacheKey = keyGenerator(page2Url, selector);
                const page2Data = await this.fetchTestimonialData(5, weblocationId, 2);
                if (page2Data?.length) {
                    await this.storeInCache(page2CacheKey, page2Data);
                }

                this.isFirstLoad = false;
                return this.ratingCache[5] ?? [];
            }

            // Not first load - get selected rating data
            const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId || 0}/${this.countryId}/0/1/${this.pageSize}/${selectedRating}`;
            const cacheKey = keyGenerator(url, selector);

            const cachedData = await this.getFromCache(cacheKey);
            if (cachedData) {
                return cachedData;
            }

            const data = await this.fetchTestimonialData(selectedRating, weblocationId);
            if (data?.length) {
                await this.storeInCache(cacheKey, data);
            }
            return data ?? [];

        } catch (error) {
            console.warn('Error fetching testimonial data:', error);
             await this.handleCacheFailure();
            // Fallback to incognito behavior
            return this.incognitoDataFetch(weblocationId, selectedRating);
        }
    }

    protected async getCompleteData(weblocationId: any, selectedRating: number) {
         // Check if in incognito mode 
        const isIncognito = await checkIncognito();
        if (isIncognito) {
            // Always return the result from incognitoDataFetch
            return await this.incognitoDataFetch(weblocationId, selectedRating);
        } else {
            // Always return the result from getDataIndexDB
            return await this.getDataIndexDB(weblocationId, selectedRating);
        }
    }

    protected showRatingSkeleton() {
        const skeleton = document.getElementById('ratingskeleton');
        const content = document.getElementById('ratingcontent');
        if (skeleton) skeleton.classList?.remove('hidden');
        if (content) content.classList?.add('is-hidden');
    }

    protected showRatingContent() {
        const skeleton = document.getElementById('ratingskeleton');
        const content = document.getElementById('ratingcontent');
        if (skeleton) skeleton.classList?.add('hidden');
        if (content) content.classList?.remove('is-hidden');
    }
    protected fetchTestimonialData(rating: number, weblocationId: any, pageNumber?: number) {
        const pageNumber1 = pageNumber ?? this.pageNumber;
        const url = apiConfig.TESTIMONIAL_REVIEWS + `/${this.conceptId}/${weblocationId || 0}/${this.countryId}/0/${pageNumber1}/${this.pageSize}/${rating}`;
        return cachedAPIWrapper(url, apiCaching.TestimonyAndReview);
    }
    private async createTestimonialLists(result: any[]): Promise<VNode[]> {
        const isIncognito = await checkIncognito();

        if (isIncognito) {
            return result
                .map(item => this.createTestimonialVNode(item) ?? null)
                .filter((item): item is VNode => item !== null);
        }

        return Array.isArray(result) && result[0]?.type
            ? result
            : result
                .map(item => this.createTestimonialVNode(item))
                .filter((node): node is VNode => node !== null);
    }
    protected async displayTestimonialData(result: any, rating: number) {
        try {
            const seeMoreButton = document.querySelector('.testi-btn-wrapper') as HTMLElement;
            this.wrapperElement?.classList.remove('hidden');
            if (seeMoreButton) {
                if (result.length === 0 || result.length < this.pageSize) {
                    seeMoreButton.style["display"] = "none";
                    isLoading = false;
                } else {
                    seeMoreButton.style["display"] = "flex";
                    isLoading = true;
                }
            }

            // Hide skeletons and show real testimonials
            const skeletonUl = document.getElementById('testimonialskeletons');
            const realUl = document.getElementById('realtestimonials');
            if (skeletonUl) skeletonUl.classList?.add('hidden');
            if (realUl) realUl.classList?.remove('hidden');
            const lists = await this.createTestimonialLists(result);

            const testimonialListNode: VNode = {
                type: 'ul',
                props: {},
                children: lists,
            };

            if (realUl) {
                updateVDomElement(realUl, testimonialListNode);
            }
        } catch (error) {
            console.warn('Error displaying testimonial data:', error);
        }
    }

    public generateRatingStars(rating: number): string {
        const fullStar = '<span class="star full">★</span>';
        const emptyStar = '<span class="star empty">☆</span>';
        const numberOfFullStars = Math.round(rating);
        const hasHalfStar = rating % 1 !== 0;
        const numberOfEmptyStars = hasHalfStar ? 5 - numberOfFullStars - 1 : 5 - numberOfFullStars;
        return fullStar.repeat(numberOfFullStars) + (hasHalfStar ? '<span class="star half">★</span>' : '') + emptyStar.repeat(numberOfEmptyStars);
    }

    public createTestimonialVNode(data: any): VNode | null {
        if (!data.reviewAuthorName) {
            return null
        }
        const fullName: string = data.reviewAuthorName
        const processedNameArray = fullName.match(/\b[a-zA-Z]+\b/g) as string[]
        let displayName = fullName;
        if (processedNameArray && processedNameArray.length === 1) {
            displayName = processedNameArray[0];
        }
        if (processedNameArray && processedNameArray.length >= 2) {
            displayName = `${processedNameArray[0]} ${processedNameArray[1].charAt(0).toUpperCase()}.`
        }
        const photoDiv = data.reviewPhotoUrl === null ?
            (getImageReplacemnt(data.reviewAuthorName, 'testimonialVdom')) :
            {
                type: 'div',
                props: { class: 'testi-profile' },
                children: [
                    {
                        type: 'img',
                        props: {
                            src: data.reviewPhotoUrl,
                            alt: 'profile photo',
                            width: 72,
                            height: 73
                        },
                        children: []
                    }
                ]
            };
        // rating stars
        const ratingStars = [];
        const starCountString = this.generateRatingStars(data.reviewStarRating ? Math.round(data.reviewStarRating) : 0);
        const starCount = (starCountString.match(/★/g) || []).length;
        for (let i = 0; i < 5; i++) {
            ratingStars.push({
                type: 'span',
                props: { class: `star ${i < starCount ? 'full' : ''}` },
                children: ['★']
            });
        }
        return {
            type: 'li',
            props: { class: 'testi-main-wrap' },
            children: [
                {
                    type: 'div',
                    props: { class: 'testi-main' },
                    children: [
                        {
                            type: 'div',
                            props: { class: 'testi-details' },
                            children: [
                                photoDiv,
                                {
                                    type: 'div',
                                    props: { class: 'testi-bio' },
                                    children: [
                                        { type: 'strong', props: { class: 'user-name' }, children: [displayName] },
                                        data.city ? { type: 'address', props: { class: 'address' }, children: [data.city] } : '',
                                        {
                                            type: 'div',
                                            props: { class: 'rating' },
                                            children: ratingStars
                                        },
                                        data.reviewSourceType ? {
                                            type: 'span',
                                            props: { class: 'review-source' },
                                            children: [`via ${data.reviewSourceType}`]
                                        } : ''
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'div',
                            props: { class: 'testi-comment' },
                            children: [
                                data.reviewBody ? { type: 'p', props: { class: 'body-text-sm' }, children: [`“${data.reviewBody}”`] } : '',
                                data.reviewResponseBody ? {
                                    type: 'div',
                                    props: { class: 'testi-reply' },
                                    children: [
                                        { type: 'p', props: { class: 'body-text-sm' }, children: ['Owner Response:'] },
                                        { type: 'p', props: { class: 'body-text-sm' }, children: [`“${data.reviewResponseBody}”`] }
                                    ]
                                } : ''
                            ]
                        }
                    ]
                }
            ]
        };
    }

    private loadmoreIncognito() {
        let ratingParam = `${this.selectedStarRating ? this.selectedStarRating : 5}`;

        const url = apiConfig.TESTIMONIAL_REVIEWS + `/${this.conceptId}/${localStorage.getItem("franchiseWebLocationId") ?? 0}/${this.countryId}/0/${this.pageNumber}/${this.pageSize}/${ratingParam}`;

        cachedAPIWrapper(url)
            .then((result: any) => {
                if (!result?.length) {
                    // hide loadmore if response is empty
                    const seeMoreButton = document.querySelector('.testi-btn-wrapper') as HTMLElement;
                    if (seeMoreButton) { seeMoreButton.style.display = 'none'; }
                    return;
                }
                this.hideNoReviewSection();
                const lists = result.map((item: any) => {
                    return this.createTestimonialVNode(item);
                });
                // Always target the real testimonials ul
                const realUl = document.getElementById('realtestimonials') as HTMLElement;
                if (realUl) {
                    // Remove hidden class if present
                    realUl.classList?.remove('hidden');
                    // Render new testimonials
                    const testimonialListNode: VNode = {
                        type: 'ul',
                        props: {},
                        children: lists,
                    };
                    updateVDomElement(realUl, testimonialListNode);
                }
                // Hide skeletons if still visible
                const skeletonUl = document.getElementById('testimonialskeletons');
                if (skeletonUl) skeletonUl.classList?.add('hidden');

                const seeMoreButton = document.querySelector('.testi-btn-wrapper') as HTMLElement;
                if (seeMoreButton) {
                    if (!result || result.length == 0 || result.length < this.pageSize) {
                        seeMoreButton.style.display = "none";
                    }
                    else {
                        seeMoreButton.style.display = "flex";
                        this.fetchNextPageSilently();
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                this.showNoReviewSection();
            });
    }
    protected async seeMoreData(event: any) {
        event.preventDefault();
        this.pageNumber++; // Increment the page number for the next page of data
        // Check if in incognito mode
        const isIncognito = await checkIncognito();
        if (isIncognito) {
            this.loadmoreIncognito();
        } else {
            const selectedRating = this.selectedStarRating ? this.selectedStarRating : 5;
            const weblocationId = localStorage.getItem("franchiseWebLocationId") ?? "0";
            const selector = '.testimonials-section';

            try {
                const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId}/${this.countryId}/0/${this.pageNumber}/${this.pageSize}/${selectedRating}`;
                const cacheKey = keyGenerator(url, selector);

                // Check cache first
                const cachedData = await this.getFromCache(cacheKey);
                if (cachedData) {
                    this.displayTestimonialData(cachedData, selectedRating);
                    // Pre-cache next page
                    const nextPage = this.pageNumber + 1;
                    this.fetchNextPageSilently(nextPage, selectedRating);
                    return;
                }

                // Fetch if not in cache
                const result = await this.fetchTestimonialData(selectedRating, weblocationId, this.pageNumber);
                if (result?.length) {
                    await this.storeInCache(cacheKey, result);
                    this.displayTestimonialData(result, selectedRating);
                    // Pre-cache next page
                    this.fetchNextPageSilently(this.pageNumber + 1, selectedRating);
                } else {
                    const seeMoreButton = document.querySelector('.testi-btn-wrapper');
                    if (seeMoreButton) {
                        seeMoreButton.classList.add('hidden');
                    }
                }
            } catch (error) {
                console.error('Error loading more testimonials:', error);
                this.showNoReviewSection();
            }
        }

    }

    protected async fetchNextPageSilently(pageNumber?: number, rating?: any) {

        // Check if in incognito mode
        const isIncognito = await checkIncognito();
        if (isIncognito) {
            // Increment pageNumber to load the next page
            const nextPageNumber = this.pageNumber + 1;

            let ratingParam = `${this.selectedStarRating ? this.selectedStarRating : 5}`;
            const url = apiConfig.TESTIMONIAL_REVIEWS + `/${this.conceptId}/${localStorage.getItem("franchiseWebLocationId") ?? 0}/${this.countryId}/0/${nextPageNumber}/${this.pageSize}/${ratingParam}`;

            // Make the silent API call to fetch the next page 
            cachedAPIWrapper(url)
                .then((result: any) => {
                    if (!result?.length) {
                        // Hide the button if the response is empty
                        const seeMoreButton = document.querySelector('.testi-btn-wrapper') as HTMLElement;
                        if (seeMoreButton) seeMoreButton.style.display = 'none';
                    } else {
                        console.log(`Page ${nextPageNumber} cached silently.`);
                    }
                })
                .catch((err) => {
                    console.error("Failed to fetch next page silently:", err);
                });
        } else {
            const weblocationId = localStorage.getItem("franchiseWebLocationId") ?? "0";
            const selector = '.testimonials-section';
            const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${weblocationId}/${this.countryId}/0/${pageNumber}/${this.pageSize}/${rating}`;
            const cacheKey = keyGenerator(url, selector);

            try {
                // Check if page is already cached
                const cachedData = await this.getFromCache(cacheKey);
                if (cachedData) {
                    console.log(`Page ${pageNumber} already cached, skipping.`);
                    return;
                }

                // Fetch next page of data
                const nextPageData: any = await this.fetchTestimonialData(rating, weblocationId, pageNumber);

                // Handle error response
                if (!Array.isArray(nextPageData) || !nextPageData.length || nextPageData.length < this.pageSize) {
                    // Hide the button if no data or invalid concept ID
                    const seeMoreButton = document.querySelector('.testi-btn-wrapper') as HTMLElement;
                    if (seeMoreButton) seeMoreButton.style.display = 'none';

                    console.warn("No testimonials found or invalid ConceptId.");
                    return;
                }

                // Cache valid result
                await this.storeInCache(cacheKey, nextPageData);
                console.log(`Page ${pageNumber} cached silently.`);
            } catch (error) {
                console.error("Failed to fetch next page silently:", error);
            }
        }

    }

    protected handleStarRatingFilter() {
        const ratingForm = document.getElementById("ratingForm");
        if (ratingForm) {
            const radioButtons = ratingForm.querySelectorAll('input[name="rating"]');
            // Add a change event listener to each radio button
            radioButtons?.forEach((radioButton) => {
                (radioButton as HTMLInputElement).onclick = () => {
                    const selectedRadio = ratingForm.querySelector('input[name="rating"]:checked') as HTMLInputElement;
                    if (selectedRadio) {
                        const realUl = document.getElementById('realtestimonials');
                        if (realUl) {
                            realUl.innerHTML = '';
                        }
                        this.selectedStarRating = parseInt(selectedRadio.value, 10);
                        this.pageNumber = 1;//reset page number to 1
                        this.getData();
                        this.showHideRatingDrpDwn();
                        this.updateStarsDisplay(this.selectedStarRating);
                        this.handleRatingDisplayChanges();
                    }
                }
            });
        }
    }

    protected handleDropdownToggle() {
        if (this.popoverElement) {
            this.showHideRatingDrpDwn()
            this.handleStarRatingFilter();
        }
    }

    protected showHideRatingDrpDwn() {
        this.popoverElement?.classList?.toggle("hidden");
        this.upArrow?.classList?.toggle("hidden");
        this.downArrow?.classList?.toggle("hidden");
    }

    protected updateStarsDisplay(rating: number) {
        const starsContainer = document.getElementById('starsDisplay');
        if (starsContainer) {
            starsContainer.innerHTML = "";
            for (let i = 0; i < rating; i++) {
                const starElement = document.createElement("span");
                starElement.className = "star full";
                starElement.innerHTML = '&#9733;';
                starsContainer.appendChild(starElement);
            }
        }
    }

    protected handleRatingDisplayChanges() {
      handleRatingDisplayChanges(this.resetLink);
    }

    protected onResetClick() {
        const ratingText = document.getElementById('ratingText');
        const ratingsInfo = document.getElementById('ratingsInfo');
        if (ratingText) {
            ratingText.textContent = this.overAllRatings;
            ratingText.classList.remove('showing-text');
            ratingText.classList.add('ratings-text');
        }
        this.resetLink?.classList.add('hidden');
        this.updateStarsDisplay(5);
        const ratingForm = document.getElementById("ratingForm");
        if (ratingForm) {
            const radioButtons = ratingForm.querySelectorAll('input[name="rating"]');
            // Add a change event listener to each radio button
            radioButtons?.forEach((radio) => {
                const inputRadio = radio as HTMLInputElement;
                inputRadio.checked = false;
            });
        }
        ratingsInfo?.classList.remove('hidden');
        ratingsInfo?.classList.add('ratings-info');
        this.popoverElement?.classList?.toggle("hidden");
        this.selectedStarRating = 0;
        const realUl = document.getElementById('realtestimonials');
        if (realUl) {
            realUl.innerHTML = '';
        }
        this.pageNumber = 1;
        this.getData();
    }

    async getTotalReviews() {
        this.showRatingSkeleton(); // Show skeleton at the start
        let weblocationId: any;
        // Check sessionStorage first
        if (localStorage.getItem("franchiseWebLocationId")) {
            weblocationId = localStorage.getItem("franchiseWebLocationId");
        } else {
            // Check if the value exists in the DOM element
            const weblocationElement = document.getElementById('weblocationId') as any;
            weblocationId = weblocationElement?.value ? weblocationElement.value : '';
        }
        const url = apiConfig.TESTIMONIAL_REVIEWS + `/${this.conceptId}/${weblocationId || 0}/${this.countryId}/1/1/1`;

        try {
            let result = await cachedAPIWrapper(url, apiCaching.TestimonyAndReview);
            if (Array.isArray(result) && result.length) {
                const totalReviews = document.querySelector("#ratingsInfo p");
                if (totalReviews) {
                    totalReviews.textContent = `${result[0]?.grandTotal} Ratings`;

                }
                const overAllRatingsdiv = document.getElementById("ratingText");
                if (overAllRatingsdiv) {
                    this.overAllRatings = `${result[0]?.overallRating}/5`;
                    overAllRatingsdiv.textContent = this.overAllRatings;
                }
            } else {
                // Clear values when API returns empty response to satisfy tests
                const totalReviews = document.querySelector("#ratingsInfo p");
                if (totalReviews) {
                    totalReviews.textContent = '';
                }
                const overAllRatingsdiv = document.getElementById("ratingText");
                if (overAllRatingsdiv) {
                    overAllRatingsdiv.textContent = '';
                }
            }
        } catch {
            console.log("Unable to fetch total ratings");
        } finally {
            this.showRatingContent(); // Always show content after response
        }

    }

    protected showNoReviewSection() {
        const testimonialsSection = document.querySelector('.testimonials-section');
        const noReviewSection = document.querySelector('.no-review-section');
        testimonialsSection?.classList.add('hidden');
        noReviewSection?.classList.remove("hidden");
    }
    protected hideNoReviewSection() {
        const testimonialsSection = document.querySelector('.testimonials-section');
        const noReviewSection = document.querySelector('.no-review-section');
        testimonialsSection?.classList.remove('hidden');
        noReviewSection?.classList.add("hidden");
    }
    private async storeInCache(key: string, data: any): Promise<void> {
        try {
            // Create VDOM nodes once
            const vdomNodes = data.map((item: any) => this.createTestimonialVNode(item))
                .filter((node: VNode | null) => node !== null);
            const hash = await createVDOMHash(vdomNodes);
            await insertTemplate(key, {
                responseHash: hash,
                generatedTemplate: JSON.stringify(vdomNodes),
                expiryTimestamp: Date.now() + (24 * 60 * 60 * 1000) // 24 hours
            });
        } catch (error) {
            console.warn('Error storing in cache:', error);
              await this.handleCacheFailure();
            // Continue with incognito mode behavior
            this.ratingCache[this.selectedStarRating] = data;
        }
    }

    private async getFromCache(key: string): Promise<any> {
        try {
            const cached = await lookupTemplate(key);
            return cached?.generatedTemplate ? JSON.parse(cached.generatedTemplate) : null;
        } catch (error) {
            console.warn('Error retrieving from cache:', error);
            await this.handleCacheFailure();
            // Return from in-memory cache if available
            return this.ratingCache[this.selectedStarRating] ?? null;
        }
    }
}
